
import { Component, OnInit, ElementRef } from '@angular/core';
import { Options } from 'ng5-slider';
import { WindowRef } from 'src/windowRef.server';

@Component({
  selector: 'app-xz',
  templateUrl: './xz.component.html',
  styleUrls: ['./xz.component.scss']
})
export class XzComponent implements OnInit {
  mgl = true;
  /* ng5-slider */
  value = 32;
  options: Options = {
    floor: 14,
    ceil: 80,
    translate: (value: number): string => {
      return value + 'px';
    }
  };
  /* ng5-slider */
  fontSize;
  sm = false; // phone boolean
  smFontSize = true;  // phone font +-
  inText = '';  // input ngModel
  text = '';
  inHTML = 'ᠣᠨᠣᠨ ᠰᠢᠷᠢᠰ ᠲᠢᠭ';
  plusData = 2; // font ++ data
  openClose = false;
  bgColor = '#ffffff';
  color = '#2C2C2C';
  reset = false;
  // tslint:disable-next-line: max-line-length
  textCont = ['  -   ', '    ', '     ', '    ', '     ', '  ', '   '];
  constructor(private windowRef: WindowRef, private el: ElementRef) {
  }
  // tslint:disable-next-line: use-lifecycle-interface
  ngDoCheck() {
    if (this.inText !== '' && this.inText !== this.text) {
      this.text = this.inText;
    } else if (this.inText === '') {
      this.text = '';
    }

    if (this.windowRef.nativeWindow.innerWidth <= 768) {
      this.sm = true;
    } else {
      this.sm = false;
    }
  }
  ngOnInit(): void { }
  // tslint:disable-next-line: use-lifecycle-interface
  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    if (this.windowRef.nativeWindow.innerWidth <= 768) {
      this.value = 32;
    }
    this.el.nativeElement.querySelector('#bt').classList.add('themeColor');
  }
  // open - close input
  OpenClose() {
    if (!this.openClose) {
      this.openClose = !this.openClose;
      this.el.nativeElement.querySelector('#In').style.height = '245px';
      this.el.nativeElement.querySelector('#iconPan').style.color = '#00b7de';
      this.el.nativeElement.querySelector('#In').style.padding = '15px 0 5px 0';
    } else {
      this.openClose = !this.openClose;
      this.el.nativeElement.querySelector('#In').style.height = '0px';
      this.el.nativeElement.querySelector('#iconPan').style.color = '';
      this.el.nativeElement.querySelector('#In').style.padding = '0';
    }
  }
  // phone font size + -
  smFs() {
    if (this.smFontSize) {
      this.smFontSize = !this.smFontSize;
      this.el.nativeElement.querySelector('#mt').classList.remove('themeColor');
      this.el.nativeElement.querySelector('#bt').classList.add('themeColor');
      this.value = 32;
    } else {
      this.smFontSize = !this.smFontSize;
      this.el.nativeElement.querySelector('#bt').classList.remove('themeColor');
      this.el.nativeElement.querySelector('#mt').classList.add('themeColor');
      this.value = 18;
    }
  }
  // font size
  font_size() {
    const style = {
      fontSize: this.value + 'px',
    };
    return style;
  }
  // bgColor , color
  Color() {
    const style = {
      backgroundColor: this.bgColor,
      color: this.color,
    };
    return style;
  }
  // astheniaColor
  astheniaColor() {
    const bgI = {
      backgroundImage: 'linear-gradient(' + this.bgColor + '00,' + this.bgColor + 'ff 60%)',
    };
    return bgI;
  }
  // reset fontSize, bgcolor, color
  Reset() {
    this.inText = '';
    this.bgColor = '#ffffff';
    this.color = '#2C2C2C';
    this.value = 32;
    if (this.openClose) {
      this.OpenClose();
    }
    if (this.smFontSize) {
      this.smFs();
    }
  }
}
